export const userStatusTypeForValue = value => {
    let type
  switch(value) {
    case 1:
      type = 'Focused'
      break
    case 2:
        type = 'Open'
        break
    case 3:
        type = 'Collaborating'
        break
    case 4:
        type = 'Inactive'
        break
    default:
        type = 'Inactive'
  }
  return type
}

export const USER_STATUS_TYPES = {
  FOCUSED: 1,
  OPEN: 2,
  COLLAB: 3,
  INACTIVE: 4,
}



// WEBPACK FOOTER //
// ./src/utils/userStatusType.js